module.exports = __webpack_public_path__ + "static/navbarlogo-97067d52d99bc23aab584a08bd76d4d6.png";